/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
import { Theme } from "@mui/material";

const settlementCostsStyle = {
  settlementCosts: {
    textAlign: "left",
  },
  noEstimate: {
    textAlign: "center",
  },
  money: (theme: Theme) => ({
    fontWeight: "bold",
    textAlign: "right",
    [theme.breakpoints.down("sm")]: {
      textAlign: "left",
    },
  }),
  moneyStrike: (theme: Theme) => ({
    fontWeight: "bold",
    textAlign: "right",
    textDecoration: "line-through",
    [theme.breakpoints.down("sm")]: {
      textAlign: "left",
    },
  }),
  divider: {
    height: 1,
    backgroundColor: "#dadada",
    margin: "1.5rem 0",
  },
  insuranceBox: (theme: Theme) => ({
    textAlign: "center",
    border: "1px solid " + theme.palette.primary.main,
    borderRadius: "5px",
    padding: "0.5rem",
    marginTop: "1.5rem",
  }),
  noRisk: {
    color: "primary.main",
    fontWeight: 500,
  },
  postfix: {
    textAlign: "center",
    fontSize: "small",
  },
};

export default settlementCostsStyle;
